module.exports = new __parcel__URL__("uninvited.e2d4feef.jpg").toString();